module.exports = require("./socket.js");


//////////////////
// WEBPACK FOOTER
// angular-socket-io (bower component)
// module id = 416
// module chunks = 1